var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleAssignFilledIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#0085FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7778 7.3H14.2233C13.9667 6.546 13.2944 6 12.5 6C11.7056 6 11.0333 6.546 10.7767 7.3H8.22222C7.55 7.3 7 7.885 7 8.6V17.7C7 18.415 7.55 19 8.22222 19H16.7778C17.45 19 18 18.415 18 17.7V8.6C18 7.885 17.45 7.3 16.7778 7.3ZM12.5 7.3C12.8361 7.3 13.1111 7.5925 13.1111 7.95C13.1111 8.3075 12.8361 8.6 12.5 8.6C12.1639 8.6 11.8889 8.3075 11.8889 7.95C11.8889 7.5925 12.1639 7.3 12.5 7.3ZM12.5 9.9C13.5144 9.9 14.3333 10.771 14.3333 11.85C14.3333 12.929 13.5144 13.8 12.5 13.8C11.4856 13.8 10.6667 12.929 10.6667 11.85C10.6667 10.771 11.4856 9.9 12.5 9.9ZM16.1667 17.7H8.83333V16.79C8.83333 15.49 11.2778 14.775 12.5 14.775C13.7222 14.775 16.1667 15.49 16.1667 16.79V17.7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleAssignFilledIcon);
export default __webpack_public_path__ + "static/media/role-assign-filled-icon.349ea82458328d76cda070211a76e969.svg";
export { ForwardRef as ReactComponent };